import { render, staticRenderFns } from "./CoopPartnersView.vue?vue&type=template&id=4bec9092&"
import script from "./CoopPartnersView.vue?vue&type=script&lang=js&"
export * from "./CoopPartnersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports